import { render, staticRenderFns } from "./BackingServices.vue?vue&type=template&id=fd530010&scoped=true&"
import script from "./BackingServices.vue?vue&type=script&lang=js&"
export * from "./BackingServices.vue?vue&type=script&lang=js&"
import style0 from "./BackingServices.vue?vue&type=style&index=0&id=fd530010&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd530010",
  null
  
)

export default component.exports